var _excluded = ["id", "bringFocusInside", "content", "placement", "offset", "children"],
    _excluded2 = ["ref"],
    _excluded3 = ["ref"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/* global document */


import * as React from "react";
import { Manager, Popper, Reference } from "react-popper";
import AriaPopup from "../AriaPopup";
import { composeRefs } from "../utils";
import PopoverPanel from "./PopoverPanel";
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function Popover(_ref) {
  var id = _ref.id,
      _ref$bringFocusInside = _ref.bringFocusInside,
      bringFocusInside = _ref$bringFocusInside === void 0 ? false : _ref$bringFocusInside,
      content = _ref.content,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "bottom" : _ref$placement,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 9 : _ref$offset,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return ___EmotionJSX(Manager, null, ___EmotionJSX(AriaPopup, {
    id: id,
    bringFocusInside: bringFocusInside
  }, function (_ref2) {
    var getTriggerProps = _ref2.getTriggerProps,
        getPopupProps = _ref2.getPopupProps,
        open = _ref2.open,
        close = _ref2.close,
        toggle = _ref2.toggle,
        isOpen = _ref2.isOpen;

    var _getTriggerProps = getTriggerProps(),
        ariaTriggerRef = _getTriggerProps.ref,
        triggerProps = _objectWithoutPropertiesLoose(_getTriggerProps, _excluded2);

    var _getPopupProps = getPopupProps(),
        ariaPopupRef = _getPopupProps.ref,
        popupProps = _objectWithoutPropertiesLoose(_getPopupProps, _excluded3);

    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Reference, null, function (_ref3) {
      var popperRef = _ref3.ref;

      var triggerPropsWithRef = _extends({}, triggerProps, {
        ref: composeRefs([popperRef, ariaTriggerRef])
      });

      if (typeof children === "function") {
        return children({
          open: open,
          close: close,
          toggle: toggle,
          isOpen: isOpen,
          triggerProps: triggerPropsWithRef
        });
      }

      var child = React.Children.only(children);
      if (!React.isValidElement(child)) return null;
      return React.cloneElement(child, triggerPropsWithRef);
    }), ___EmotionJSX(Popper, {
      placement: placement,
      modifiers: {
        offset: {
          enabled: true,
          offset: "0, " + offset
        },
        computeStyle: {
          gpuAcceleration: false
        },
        preventOverflow: {
          boundariesElement: typeof document !== "undefined" ? document.body : undefined,
          padding: 12
        }
      }
    }, function (_ref4) {
      var popperRef = _ref4.ref,
          style = _ref4.style,
          actualPlacement = _ref4.placement,
          arrowProps = _ref4.arrowProps;
      return ___EmotionJSX(PopoverPanel, _extends({}, props, popupProps, {
        isOpen: isOpen,
        ref: composeRefs([popperRef, ariaPopupRef]),
        style: style,
        placement: actualPlacement,
        arrowProps: arrowProps
      }), typeof content === "function" ? content({
        open: open,
        close: close,
        toggle: toggle,
        isOpen: isOpen
      }) : content);
    }));
  }));
}